import CardContent from "@material-ui/core/CardContent";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import Helmet from "react-helmet";
import headersList from "Constants/headersList";
import Brush from "@material-ui/icons/Brush";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
// import queryString from 'query-string';
import React from "react";
import { IntlProvider } from "react-intl";
import get from "lodash/get";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { instance } from "../../../Actions/AxiosInstance";
import {
  CheckActionPermission,
  setHelperText,
} from "../../../Actions/commonAction";
import Banking from "../../../Assets/Icons/bankaccount.svg";
import Book from "../../../Assets/Icons/books.svg";
import Contact from "../../../Assets/Icons/contact.svg";
import Dependents from "../../../Assets/Icons/dependents.svg";
import Identity from "../../../Assets/Icons/identity.svg";
import {
  default as ImportantDates,
  default as LifeEvent,
} from "../../../Assets/Icons/importantdates.svg";
import Intrest from "../../../Assets/Icons/intrest.svg";
import LanguageIcon from "../../../Assets/Icons/language.svg";
import Address from "../../../Assets/Icons/location.svg";
import Medical from "../../../Assets/Icons/medical.svg";
import Movie from "../../../Assets/Icons/movie.svg";
import Music from "../../../Assets/Icons/music.svg";
import {
  default as About,
  default as Personal,
} from "../../../Assets/Icons/personal.svg";
import sumhr from "../../../Assets/Icons/sumhr.png";
import createstore from "../../../store";
import { SubscriptionLogin } from "../../../Actions/AuthenticationAction";

import { ChangeLanguage } from "../../../Actions/LanguageAction";
import If from "../../../Component/Common/If";
import TabContainer from "../../../Component/Common/TabContainer";
import "./Profile.css";

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  tabheading: {
    fontSize: 16,
    textTransform: "capitalize",
    padding: 0,
  },
  button: {
    margin: theme.spacing.unit,
  },
});
class ProfilePrivacy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checkAdmin: this.props.location.search,
      subscriptionid: "",
      isSelf: get(this.props, "history.location.pathname", "").includes(
        "/personal_privacy",
      ),
      date: false,
      port: window.location.port,
      privacymodename: "",
      PrivacyComponents: [],
      privacyMode: [],
      isAdmin: false,
      title: get(this.props, "history.location.pathname", "").includes(
        "/global_privacy",
      )
        ? "Employee / Global Profile Privacy"
        : "Employee / Profile Privacy",
      permissions: { readOnly: false, editable: false },
    };
    this.UpdatePrivacy = this.UpdatePrivacy.bind(this);
  }

  componentDidMount() {
    this.props.setHelperText("");
    const [isTrue, permissions] = CheckActionPermission(
      get(this.props, "history.location.pathname", "").includes(
        "/global_privacy",
      )
        ? "globalProfilePrivacy"
        : "personalProfilePrivacy",
    );
    if (isTrue) {
      this.setState({ permissions });
    } else {
      // this.props.history.push("404");
      this.setState({ permissiondenied: true });
    }
  }

  componentWillMount() {
    this.GetPrivacyMode();
    this.props.ChangeLanguage("");
    let isAdmin;
    let pathSearch = this.props.location.search || "";
    pathSearch = pathSearch.replace("?checkAdmin=", "");
    pathSearch == "adminPrivacy" ? (isAdmin = true) : (isAdmin = false);
    const { AuthenticationAction } = createstore.getState();
    const { subscriptionid } = AuthenticationAction.login;
    const { accountid } = AuthenticationAction.login;
    const { employeeid } = AuthenticationAction.login;
    const masterprofileid = get(
      AuthenticationAction,
      "login.masterprofileid",
      9,
    );
    this.setState(
      {
        accountid,
        subscriptionid,
        employeeid,
        masterprofileid,
        isAdmin,
      },
      () => {
        console.log("isAdmin: ", isAdmin);
        this.GetPrivacyComponents();
      },
    );
  }

  GetPrivacyMode() {
    const URL = "superuser/getmastercode/PrivacyMode";
    instance
      .get(URL)
      .then((result) => {
        let privacyMode = [];
        privacyMode.push(...result.data.result);
        if (this.state.isSelf) {
          privacyMode = privacyMode.filter((x) => x.displayvalue != 99);
        }
        this.setState({ privacyMode });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetPrivacyComponents() {
    let URL = "";
    if (!this.state.isSelf) {
      URL = `users/subprivacymenu`;
    } else {
      URL = `users/empprivacymenu/${this.state.employeeid}`;
    }
    instance
      .get(URL)
      .then((result) => {
        const PrivacyComponents = result.data.result;
        this.setState({ PrivacyComponents });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  UpdatePrivacy(index, comp, e) {
    const { PrivacyComponents } = this.state;
    let privacymodename;
    let URL = "";
    let data = {};
    for (const mode of this.state.privacyMode) {
      if (mode.displayvalue == e.target.value) {
        privacymodename = mode.displayname;
      }
    }
    PrivacyComponents[index].privacymodeid = parseInt(e.target.value);
    PrivacyComponents[index].privacymodename = privacymodename;
    PrivacyComponents[index].isPrivacyChange = false;

    if (!this.state.isSelf) {
      URL = `users/subprivacymenu`;
      data = {
        privacy: [
          {
            subscriptionprivacymenuid: comp.subscriptionprivacymenuid || 0,
            privacymenuid: comp.privacymenuid,
            privacymodeid: parseInt(e.target.value),
          },
        ],
      };
      instance
        .post(URL, data)
        .then((result) => {
          PrivacyComponents[index].subscriptionprivacymenuid =
            result.data.result[0].subscriptionprivacymenuid;
          this.props.enqueueSnackbar("Privacy Successfully Updated", {
            variant: "success",
          });
          this.setState({ PrivacyComponents });

          this.setState({
            PrivacyComponents: PrivacyComponents.slice(
              0,
              PrivacyComponents.length,
            ),
          });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else {
      URL = `users/empprivacymenu/${this.state.employeeid}`;
      data = {
        privacy: [
          {
            privacymenuid: comp.privacymenuid,
            privacymodeid: parseInt(e.target.value),
          },
        ],
      };
      instance
        .put(URL, data)
        .then((result) => {
          this.props.enqueueSnackbar("Privacy Successfully Updated", {
            variant: "success",
          });
          this.setState({ PrivacyComponents });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          // this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  ChangePrivacy(index, e) {
    const { PrivacyComponents } = this.state;
    PrivacyComponents.map((x) => {
      x.isPrivacyChange = false;
    });
    PrivacyComponents[index].isPrivacyChange = true;
    this.setState({ PrivacyComponents });
  }

  OnCancel(index, e) {
    const { PrivacyComponents } = this.state;
    PrivacyComponents[index].isPrivacyChange = false;
    this.setState({ PrivacyComponents });
  }

  render() {
    const { Language } = this.props;
    const language = Language.addEmployee;
    // console.log( "selectionReducer", this.props.selectionReducer);

    const getDisable = (empdecide) => {
      if (this.state.permissions.editable) {
        if (this.state.isSelf) {
          if (empdecide) {
            return false;
          }
          return true;
        }
        return false;
      }
      return true;
    };

    return (
      <IntlProvider locale="en" messages={language}>
        <main className="content-outer-wrapper" style={{ paddingBottom: 0 }}>
          <Helmet>
            <title>{headersList.Config.DefaultProfilePrivacy.header}</title>
          </Helmet>
          {this.state.permissiondenied ? (
            <div className="position-rel">
              <PermissionDeniedComp />
            </div>
          ) : (
            <Grid container>
              {this.state.PrivacyComponents.slice(
                0,
                this.state.PrivacyComponents.length,
              ).map((comp, index) => (
                <Grid key={comp} item xs={12} sm={6} md={3}>
                  <CardContent className="nopadding margin-bottom-32">
                    <div
                      className={
                        comp.isPrivacyChange ||
                        this.props.selectionReducer.openLeftDrawer == true
                          ? "privacy-block-closed inlineClass position-rel hover"
                          : "privacy-block inlineClass position-rel "
                      }
                    >
                      <div className="width100">
                        <div className="cardHeader">
                          <div className="floatleft margin-right-8">
                            <If condition={comp.privacymenuid == 1}>
                              <span>
                                <Brush
                                  style={{ marginTop: 5, color: "white" }}
                                />
                              </span>
                            </If>
                            <If condition={comp.privacymenuid == 3}>
                              <span>
                                <img
                                  src={LanguageIcon}
                                  alt="icon"
                                  height="30"
                                />
                              </span>
                            </If>
                            <If condition={comp.privacymenuid == 5}>
                              <span>
                                <img src={Music} alt="icon" height="30" />
                              </span>
                            </If>
                            <If condition={comp.privacymenuid == 7}>
                              <span>
                                <img src={Book} alt="icon" height="30" />
                              </span>
                            </If>
                            <If condition={comp.privacymenuid == 9}>
                              <span>
                                <img src={Contact} alt="icon" height="30" />
                              </span>
                            </If>
                            <If condition={comp.privacymenuid == 11}>
                              <span>
                                <img
                                  src={ImportantDates}
                                  alt="icon"
                                  height="30"
                                />
                              </span>
                            </If>
                            <If condition={comp.privacymenuid == 13}>
                              <span>
                                <img src={Medical} alt="icon" height="30" />
                              </span>
                            </If>
                            <If condition={comp.privacymenuid == 15}>
                              <span>
                                <img src={Banking} alt="icon" height="30" />
                              </span>
                            </If>
                            <If condition={comp.privacymenuid == 2}>
                              <span>
                                <img src={LifeEvent} alt="icon" height="30" />
                              </span>
                            </If>
                            <If condition={comp.privacymenuid == 4}>
                              <span>
                                <img src={Intrest} alt="icon" height="30" />
                              </span>
                            </If>
                            <If condition={comp.privacymenuid == 6}>
                              <span>
                                <img src={Movie} alt="icon" height="30" />
                              </span>
                            </If>
                            <If condition={comp.privacymenuid == 8}>
                              <span>
                                <img src={Address} alt="icon" height="30" />
                              </span>
                            </If>
                            <If condition={comp.privacymenuid == 10}>
                              <span>
                                <img src={Personal} alt="icon" height="30" />
                              </span>
                            </If>
                            <If condition={comp.privacymenuid == 12}>
                              <span>
                                <img src={Dependents} alt="icon" height="30" />
                              </span>
                            </If>
                            <If condition={comp.privacymenuid == 14}>
                              <span>
                                <img src={Identity} alt="icon" height="30" />
                              </span>
                            </If>
                            <If condition={comp.privacymenuid == 16}>
                              <span>
                                <img src={About} alt="icon" height="30" />
                              </span>
                            </If>
                            <If condition={comp.privacymenuid == 17}>
                              <span>
                                <img src={About} alt="icon" height="25px" />
                              </span>
                            </If>
                          </div>
                          <div className="privacy-sublabel">
                            {comp.privacymenuname}
                          </div>
                        </div>
                        <div className="radiobutton">
                          <RadioGroup
                            aria-label="Gender"
                            name="gender1"
                            onChange={(e) => this.UpdatePrivacy(index, comp, e)}
                            value={comp.privacymodeid}
                          >
                            {this.state.privacyMode.map((mode, id) => (
                              <FormControlLabel
                                key={id}
                                value={mode.displayvalue}
                                control={<Radio color="primary" />}
                                label={mode.displayname}
                                className="privacyRadiobtn"
                                disabled={getDisable(comp.isemployeedecide)}
                              />
                            ))}
                          </RadioGroup>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Grid>
              ))}
            </Grid>
          )}
        </main>
      </IntlProvider>
    );
  }
}

ProfilePrivacy.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  SubscriptionInfo: state.SubscriptionInfo,
  Language: state.LanguageAction.Language,
  selectionReducer: state.selectionReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      SubscriptionLogin: (data) => SubscriptionLogin(data),
      ChangeLanguage: (data) => ChangeLanguage(data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(ProfilePrivacy)));
